import { useEffect, useState } from 'react';

import { ContentSwitcherValue } from '../../../types';
import { getDefaultItems } from '../../../utils/content/getDefaultItems';

export const useContentManagerValues = (
  defaultValues = '',
): [
  ContentSwitcherValue[],
  (values: ContentSwitcherValue[]) => void,
  Record<string, string>,
] => {
  const [values, setValues] = useState<ContentSwitcherValue[]>(
    defaultValues && JSON.parse(defaultValues)?.values
      ? JSON.parse(defaultValues)?.values
      : [],
  );

  const [defaultItems, setDefaultItems] = useState<Record<string, string>>(
    getDefaultItems(values),
  );

  // pagesValues can change based on the page
  useEffect(() => {
    if (typeof defaultValues === 'string') {
      try {
        if (defaultValues.length === 0) {
          setValues([]);
          setDefaultItems({});
        } else if (JSON.parse(defaultValues)?.values) {
          const { values: nextValues = [] } = JSON.parse(defaultValues);
          setValues(nextValues);
          setDefaultItems(getDefaultItems(nextValues));
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [defaultValues]);

  return [values, setValues, defaultItems];
};
